export const fuseNavigationConfig = [
    {
        'id'      : 'applications',
        'title'   : 'Menu',
        'type'    : 'group',
        'icon'    : 'apps',
        'children': [
            {
                'id'   : 'beranda-component',
                'title': 'Beranda',
                'type' : 'item',
                'icon' : 'home',
                'url'  : '/Beranda'
            }
            ,{
                'id'   : 'pengaturan-component',
                'title': 'Pengaturan',
                'type' : 'collapse',
                'icon' : 'airplay',
                'children': [
                    {
                        'id'   : 'profil-pengguna-component',
                        'title': 'Profil Pengguna',
                        'type' : 'item',
                        'icon' : 'contacts',
                        'url'  : '/ProfilPengguna'
                    }
                    ,{
                        'id'   : 'manajemen-pengguna-component',
                        'title': 'Manajemen Pengguna',
                        'type' : 'item',
                        'icon' : 'account_circle',
                        'url'  : '/ManajemenPengguna'
                    }
                    ,{
                        'id'   : 'tukar-pengguna-component',
                        'title': 'Tukar Pengguna',
                        'type' : 'item',
                        'icon' : 'sync',
                        'url'  : '/TukarPengguna'
                    }                    
                    // ,{
                    //     'id'   : 'backup-restore-component',
                    //     'title': 'Backup',
                    //     'type' : 'item',
                    //     'icon' : 'replay',
                    //     'url'  : '/BackupRestore'
                    // }                    
                ]
            }
            ,{
                'id'   : 'kuesioner-component',
                'title': 'Kuesioner',
                'type' : 'collapse',
                'icon' : 'confirmation_number',
                'children': [
                    {
                        'id'   : 'perangkat-kuesioner-component',
                        'title': 'Isi Kuesioner',
                        'type' : 'item',
                        'icon' : 'ballot',
                        'url'  : '/PerangkatKuesioner'
                    }
                    ,{
                        'id'   : 'unggah-hasil-supervisi',
                        'title': 'Upload File Isian Instrumen',
                        'type' : 'item',
                        'icon' : 'file_copy',
                        'url'  : '/unggah-hasil-supervisi'
                    }
                    ,{
                        'id'   : 'peringkat-pengisian-component',
                        'title': 'Peringkat Pengisian',
                        'type' : 'item',
                        'icon' : 'check_circle',
                        'url'  : '/PeringkatPengisian'
                    }
                    // ,{
                    //     'id'   : 'konfirmasi-selesai-component',
                    //     'title': 'Sinkronisasi',
                    //     'type' : 'item',
                    //     'icon' : 'check_circle',
                    //     'url'  : '/KonfirmasiSelesai'
                    // }
                ]
            }
            // ,{
            //     'id'   : 'sinkronisasi-link',
            //     'title': 'Sinkronisasi',
            //     'type' : 'item',
            //     'icon' : 'sync',
            //     'url'  : 'http://localhost:1747/sinkronisasi.php'
            // }
            ,{
                'id'   : 'kirim_data-component',
                'title': 'Kirim Data',
                'type' : 'item',
                'icon' : 'send',
                'url'  : '/KirimData'
            }
            // ,{
            //     'id'   : 'backup-restore-component',
            //     'title': 'Backup/Restore',
            //     'type' : 'item',
            //     'icon' : 'settings_backup_restore',
            //     'url'  : '/BackupRestore'
            // }
            ,{
                'id'   : 'rapor-mutu-component',
                'title': 'Rapor Mutu',
                'type' : 'collapse',
                'icon' : 'class',
                'children': [
                    {
                        'id'   : 'hitung-rapor-mutu-component',
                        'title': 'Hitung Rapor Mutu',
                        'type' : 'item',
                        'icon' : 'autorenew',
                        'url'  : '/RaporMutu'
                    }
                    ,{
                        'id'   : 'hasil-rapor-mutu-component',
                        'title': 'Hasil Rapor Mutu',
                        'type' : 'item',
                        'icon' : 'class',
                        'url'  : '/HasilRaporMutu'
                    }
                    ,{
                        'id'   : 'pakta-integritas-mutu-component',
                        'title': 'Pakta Integritas',
                        'type' : 'item',
                        'icon' : 'assignment_turned_in',
                        'url'  : '/PaktaIntegritas'
                    }
                ]
            }
            ,{
                'id'   : 'konfirmasi-selesai-component',
                'title': 'Sinkronisasi',
                'type' : 'item',
                'icon' : 'check_circle',
                'url'  : '/Sinkronisasi'
            }
            ,{
                'id'   : 'verval-supervisi-component',
                'title': 'Verval dan Supervisi',
                'type' : 'collapse',
                'icon' : 'compare',
                'children': [
                    // {
                    //     'id'   : 'daftar-notifikasi-component',
                    //     'title': 'Daftar Notifikasi',
                    //     'type' : 'item',
                    //     'icon' : 'notifications',
                    //     'url'  : '/Notifikasi'
                    // }
                    {
                        'id'   : 'hasil-verval-component',
                        'title': 'Hasil Verval',
                        'type' : 'item',
                        'icon' : 'done_outline',
                        'url'  : '/HasilVerval'
                    }
                    ,{
                        'id'   : 'hasil-supervisi-mutu-component',
                        'title': 'Hasil Supervisi',
                        'type' : 'item',
                        'icon' : 'event_note',
                        'url'  : '/HasilSupervisi'
                    }
                ]
            }
            ,{
                'id'   : 'daftar-notifikasi-component',
                'title': 'Notifikasi',
                'type' : 'item',
                'icon' : 'notifications',
                'url'  : '/Notifikasi'
            }
            ,{
                'id'   : 'pusat-unduhan-component',
                'title': 'Pusat Unduhan',
                'type' : 'item',
                'icon' : 'cloud_download',
                'url'  : '/PusatUnduhan'
            }
            ,{
                'id'   : 'masukan-saran-component',
                'title': 'Laporan & Saran',
                'type' : 'item',
                'icon' : 'book',
                'url'  : '/LaporanSaran'
            }
        ]
    }
];

// // console.log(JSON.parse(localStorage.getItem('user')).peran_id);
// if(localStorage.getItem('user') !== '' && localStorage.getItem('user') !== null){

//     switch (JSON.parse(localStorage.getItem('user')).peran_id) {
//         case 13: // pengawas
//             fuseNavigationConfig[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
//             fuseNavigationConfig[0].children.splice(4,1); // menghilangkan menu kirim data
//             break;
//         case 14: // komite
//             fuseNavigationConfig[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
//             fuseNavigationConfig[0].children.splice(4,1); // menghilangkan menu kirim data
//             break;
//         case 90: // Peserta Didik
//             fuseNavigationConfig[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
//             fuseNavigationConfig[0].children.splice(4,1); // menghilangkan menu kirim data
//             break;
//         case 12: // Peserta Didik
//             fuseNavigationConfig[0].children[1].children.splice(1,2); // menghilangkan menu manajemen dan tukar pengguna
//             fuseNavigationConfig[0].children.splice(4,1); // menghilangkan menu kirim data
//             break;
//         default:
//             // do nothing
//             break;
//     }
// }

// console.log(fuseNavigationConfig[0].children[1]);



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseNavigationConfig.js